(function () {
  if (window.__emInit) return;
  window.__emInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------- Reveals ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('em-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(root) {
    root.querySelectorAll('.em-reveal, .em-cmp').forEach(function (el) {
      if (!once(el, 'emRev')) return;
      if (!io || reduce) { el.classList.add('em-visible'); return; }
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        requestAnimationFrame(function () { el.classList.add('em-visible'); });
        return;
      }
      io.observe(el);
    });
  }

  /* ---------- Hero spotlight ---------- */
  function initHero(root) {
    root.querySelectorAll('[data-em-hero]').forEach(function (hero) {
      if (!once(hero, 'emHero') || reduce || !fine) return;
      var glow = hero.querySelector('.em-hero-glow');
      if (!glow) return;
      hero.addEventListener('pointermove', function (ev) {
        var r = hero.getBoundingClientRect();
        glow.style.setProperty('--gx', ((ev.clientX - r.left) / r.width * 100) + '%');
        glow.style.setProperty('--gy', ((ev.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }

  /* ---------- Magnetic buttons ---------- */
  function initMagnetic(root) {
    if (reduce || !fine) return;
    root.querySelectorAll('[data-em-magnetic]').forEach(function (btn) {
      if (!once(btn, 'emMag')) return;
      btn.addEventListener('pointermove', function (ev) {
        var r = btn.getBoundingClientRect();
        btn.style.setProperty('--mx', ((ev.clientX - r.left - r.width / 2) * 0.12) + 'px');
        btn.style.setProperty('--my', ((ev.clientY - r.top - r.height / 2) * 0.2) + 'px');
      });
      btn.addEventListener('pointerleave', function () {
        btn.style.setProperty('--mx', '0px');
        btn.style.setProperty('--my', '0px');
      });
    });
  }

  /* ---------- Horizontal chapters ---------- */
  var hscrolls = [];
  function initHScroll(root) {
    root.querySelectorAll('[data-em-hscroll]').forEach(function (sec) {
      if (!once(sec, 'emH')) return;
      hscrolls.push(sec);
    });
    updateHScroll();
  }
  function updateHScroll() {
    var desktop = window.innerWidth >= 990 && !reduce;
    hscrolls.forEach(function (sec) {
      var outer = sec.querySelector('.em-rit-outer');
      var track = sec.querySelector('.em-rit-track');
      if (!outer || !track) return;
      if (!desktop) { track.style.transform = ''; outer.style.height = ''; return; }
      var distance = Math.max(0, track.scrollWidth - window.innerWidth + 48);
      outer.style.height = (window.innerHeight + distance) + 'px';
      var r = outer.getBoundingClientRect();
      var total = outer.offsetHeight - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      track.style.transform = 'translate3d(' + (-distance * p) + 'px,0,0)';
    });
  }

  /* ---------- Magnetic cards ---------- */
  function initCards(root) {
    if (reduce || !fine) return;
    root.querySelectorAll('[data-em-tilt]').forEach(function (card) {
      if (!once(card, 'emTilt')) return;
      card.addEventListener('pointermove', function (ev) {
        var r = card.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width, y = (ev.clientY - r.top) / r.height;
        card.style.setProperty('--ry', ((x - 0.5) * 8) + 'deg');
        card.style.setProperty('--rx', ((0.5 - y) * 8) + 'deg');
        card.style.setProperty('--px', (x * 100) + '%');
        card.style.setProperty('--py', (y * 100) + '%');
      });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- Body map ---------- */
  function initMap(root) {
    root.querySelectorAll('[data-em-map]').forEach(function (wrap) {
      if (!once(wrap, 'emMap')) return;
      var spots = wrap.querySelectorAll('[data-em-spot]');
      var zones = wrap.querySelectorAll('[data-em-zone]');
      function activate(i) {
        spots.forEach(function (s) { s.classList.toggle('is-active', s.dataset.emSpot === i); });
        zones.forEach(function (z) { z.classList.toggle('is-active', z.dataset.emZone === i); });
      }
      spots.forEach(function (s) { s.addEventListener('click', function () { activate(s.dataset.emSpot); }); });
      zones.forEach(function (z) {
        z.addEventListener('click', function () { activate(z.dataset.emZone); });
        z.addEventListener('mouseenter', function () { activate(z.dataset.emZone); });
      });
      if (zones[0]) activate(zones[0].dataset.emZone);
    });
  }

  /* ---------- Words that light up ---------- */
  var frases = [];
  function initFrase(root) {
    root.querySelectorAll('[data-em-frase]').forEach(function (el) {
      if (!once(el, 'emFrase')) return;
      frases.push(el);
    });
    updateFrase();
  }
  function updateFrase() {
    frases.forEach(function (el) {
      var words = el.querySelectorAll('.em-w');
      if (reduce) { words.forEach(function (w) { w.classList.add('is-on'); }); return; }
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight;
      var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      p = Math.min(1, Math.max(0, p));
      var n = Math.round(p * words.length);
      words.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
    });
  }

  /* ---------- Light slider ---------- */
  function initLuz(root) {
    root.querySelectorAll('[data-em-luz]').forEach(function (wrap) {
      if (!once(wrap, 'emLuz')) return;
      var range = wrap.querySelector('input[type=range]');
      var states = wrap.querySelectorAll('[data-em-state]');
      var stage = wrap.querySelector('.em-luz-stage');
      if (!range || !states.length) return;
      range.max = states.length - 1;
      function show(i) {
        states.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        if (stage && states[i]) stage.style.setProperty('--em-luz', states[i].dataset.color);
      }
      range.addEventListener('input', function () { show(parseInt(range.value, 10)); });
      show(parseInt(range.value, 10) || 0);
    });
  }

  /* ---------- Bundle: add both to cart ---------- */
  function initPack(root) {
    root.querySelectorAll('[data-em-pack]').forEach(function (form) {
      if (!once(form, 'emPack')) return;
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var btn = form.querySelector('button');
        var msg = form.querySelector('.em-pack-msg');
        var ids = (form.dataset.ids || '').split(',').filter(Boolean);
        if (!ids.length) return;
        btn.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
        }).then(function (r) {
          if (!r.ok) throw new Error('add');
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        }).catch(function () {
          btn.disabled = false;
          if (msg) msg.textContent = form.dataset.error || 'Une erreur est survenue. Veuillez réessayer.';
        });
      });
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    root.querySelectorAll('[data-em-faq]').forEach(function (faq) {
      if (!once(faq, 'emFaq')) return;
      faq.querySelectorAll('.em-faq-q').forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.em-faq-item');
          var open = !item.classList.contains('is-open');
          item.classList.toggle('is-open', open);
          q.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Product page ---------- */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }
  function initPdp(root) {
    root.querySelectorAll('[data-em-pdp]').forEach(function (pdp) {
      if (!once(pdp, 'emPdp')) return;
      var main = pdp.querySelector('[data-em-main]');
      pdp.querySelectorAll('[data-em-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          pdp.querySelectorAll('[data-em-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (main) { main.src = t.dataset.full; main.srcset = ''; }
        });
      });

      var qty = pdp.querySelector('[data-em-qty]');
      if (qty) {
        var input = qty.querySelector('input');
        qty.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10);
            input.value = Math.max(1, v);
          });
        });
      }

      var json = pdp.querySelector('[data-em-variants]');
      var selects = pdp.querySelectorAll('[data-em-option]');
      var idInput = pdp.querySelector('input[name=id]');
      var submit = pdp.querySelector('[data-em-submit]');
      var price = pdp.querySelector('[data-em-price]');
      var compare = pdp.querySelector('[data-em-compare]');
      var fmt = pdp.dataset.moneyFormat;
      if (json && selects.length) {
        var variants = JSON.parse(json.textContent);
        selects.forEach(function (s) {
          s.addEventListener('change', function () {
            var chosen = Array.prototype.map.call(selects, function (x) { return x.value; });
            var v = variants.find(function (vv) { return vv.options.every(function (o, i) { return o === chosen[i]; }); });
            if (!v) {
              submit.disabled = true; submit.textContent = submit.dataset.unavailable; return;
            }
            idInput.value = v.id;
            price.textContent = money(v.price, fmt);
            if (compare) {
              compare.style.display = v.compare_at_price > v.price ? '' : 'none';
              compare.textContent = v.compare_at_price ? money(v.compare_at_price, fmt) : '';
            }
            submit.disabled = !v.available;
            submit.textContent = v.available ? submit.dataset.available : submit.dataset.soldout;
            if (v.image && main) main.src = v.image;
          });
        });
      }

      var sticky = document.querySelector('[data-em-sticky]');
      if (sticky && submit && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          sticky.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
        }).observe(submit);
        sticky.querySelector('button').addEventListener('click', function () {
          submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  }

  function initAll(root) {
    root = root && root.querySelectorAll ? root : document;
    initReveals(root); initHero(root); initMagnetic(root); initHScroll(root); initCards(root);
    initMap(root); initFrase(root); initLuz(root); initPack(root); initFaq(root); initPdp(root);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { updateHScroll(); updateFrase(); ticking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
